var isAttendeeTypeAdjustment = function (order) {
    var attendeeNumbers = order.attendees.map(function (x) { return x.attendeeNumber; });
    if (order.isAdjustment &&
        order.attendees.length === 2 &&
        order.attendees.filter(function (x) { return x.orderQuantity >= 0; }).length === 1 &&
        order.attendees.filter(function (x) { return x.orderQuantity < 0; }).length === 1 &&
        attendeeNumbers[0] === attendeeNumbers[1]) {
        return true;
    }
    return false;
};
export { isAttendeeTypeAdjustment };
